import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateFavouriteUserFolderMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ favouriteUserFolderParams }) => {
      const response = await axios.post('/favourite_user_folders', {
        favourite_user_folder: favouriteUserFolderParams,
      });

      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries(['folders']),
  });
}

export function useUpdateFavouriteUserFolderMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ favouriteUserFolderParams, id }) => {
      const response = await axios.patch(`/favourite_user_folders/${id}`, {
        favourite_user_folder: favouriteUserFolderParams,
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['folders', 'favourites']);
    },
  });
}

export function useDestroyFavouriteUserFolderMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.delete(`/favourite_user_folders/${id}`);
      return response.data;
    },
    onSuccess: () => queryClient.invalidateQueries(['folders']),
  });
}
